import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { colors } from "../../../theme/palette";
import { EventStatus } from "../../../types/types";

import { styleConfig } from "./EventCard.styles";

interface EventCardHeaderProps {
  eventType: string | null;
  eventStatus: string | null;
  status?: EventStatus;
  isCanceled: boolean;
}

const EventCardHeader = ({ eventType, eventStatus, status, isCanceled }: EventCardHeaderProps) => {
  const { t } = useTranslation();

  const statusColor =
    status === "FINISHED"
      ? styleConfig.statusColors.finished
      : status === "SOON"
      ? styleConfig.statusColors.soon
      : status === "ACTIVE"
      ? styleConfig.statusColors.active
      : styleConfig.statusColors.default;

  return (
    <Box sx={{ display: "flex", columnGap: "12px" }}>
      {(isCanceled || eventType) && (
        <Chip
          label={isCanceled ? t("pages.events.eventList.CANCELLED") : eventType}
          sx={{
            ...styleConfig.chipBase,
            ...styleConfig.typeChip,
          }}
        />
      )}

      {eventStatus && (
        <Chip
          label={eventStatus}
          sx={{
            ...styleConfig.chipBase,
            color: colors.White,
            background: statusColor,
          }}
        />
      )}
    </Box>
  );
};

export default EventCardHeader;
